/* Levoret: swatch hover/click swaps the card image */
(function () {
  if (window.__lvCards) return;
  window.__lvCards = true;
  function swap(btn) {
    var card = btn.closest('[data-lv-card]');
    if (!card) return;
    var img = card.querySelector('.lv-pcard__img');
    if (!img || img.tagName !== 'IMG') return;
    if (!img.dataset.origSrc) { img.dataset.origSrc = img.src; img.dataset.origSrcset = img.getAttribute('srcset') || ''; }
    card.querySelectorAll('.lv-pcard__sw').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    if (btn.dataset.img) {
      img.src = btn.dataset.img;
      if (btn.dataset.srcset) img.setAttribute('srcset', btn.dataset.srcset);
      card.classList.add('is-swatching');
    }
  }
  function reset(card) {
    var img = card.querySelector('.lv-pcard__img');
    if (!img || !img.dataset.origSrc || card.dataset.locked) return;
    img.src = img.dataset.origSrc;
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    card.classList.remove('is-swatching');
    card.querySelectorAll('.lv-pcard__sw').forEach(function (b) { b.classList.remove('is-active'); });
  }
  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest && e.target.closest('.lv-pcard__sw');
    if (btn) swap(btn);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.lv-pcard__swatches');
    if (sw && !sw.contains(e.relatedTarget)) reset(sw.closest('[data-lv-card]'));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lv-pcard__sw');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-lv-card]');
    card.dataset.locked = '1';
    swap(btn);
  });
})();
